import { formatFollowers, getPlatformImage } from '../../../../utils/global';
import AvatarComponent from '../../../common-components/AvatarComponent/AvatarComponent';

export default function ProfileCard({ userDetails, profile }) {
  const postsCount = userDetails?.posts_count
    ? formatFollowers(userDetails?.posts_count)
    : profile?.total_posts
    ? formatFollowers(profile?.total_posts)
    : '-';
  const followers = userDetails?.followers
    ? formatFollowers(userDetails?.followers)
    : profile?.followers
    ? formatFollowers(profile?.followers)
    : '-';
  return (
    <div className="demographics-card" style={{ borderRadius: '8px' }}>
      <div className="profile-card">
        <div className="top-div">
          <AvatarComponent
            src={userDetails?.picture}
            alt={userDetails?.username || userDetails?.fullname?.replaceAll(' ', '').toLowerCase()}
            size={48}
          />
          <div className="followers-container">
            <div className="follow-card">
              <span>Total {userDetails?.type === 'youtube' ? 'Uploads' : 'Posts'}</span>
              <p>{postsCount}</p>
            </div>
            <div className="follow-card">
              <span>{userDetails?.type === 'youtube' ? 'Subscribers' : 'Followers'}</span>
              <p>{followers}</p>
            </div>
            {userDetails?.type !== 'youtube' && (
              <div className="follow-card">
                <span>Following</span>
                <p>{userDetails?.following ? formatFollowers(userDetails?.following) : '-'}</p>
              </div>
            )}
          </div>
        </div>
        <div className="profile-name-div">
          <div className="profile-name">
            <p className="name">{userDetails?.fullname}</p>
          </div>
          <a href={userDetails?.url} target="_blank" rel="noopener noreferrer">
            <p className="user-name">
              @{userDetails?.username || userDetails?.fullname?.replaceAll(' ', '').toLowerCase()}
              <img className="platform-image" src={getPlatformImage(userDetails?.type)} alt="platform" />
            </p>
          </a>
        </div>
        <div className="bio-container">
          <span>Bio</span>
          <p>{userDetails?.description || profile?.bio || 'N/A'}</p>
        </div>
      </div>
    </div>
  );
}
